export enum RouteEnum {
    home="home",
    consumption="consumption",
    bills="bills",
    subscription="subscription",
    profile="profile",
    offers="offers",
    energy="energy",
    support="support",
    logout="logout"
}